import { createSelector } from '@reduxjs/toolkit';
import { fetchStatuses } from '../../../constants/fetchStatuses';
import { ReducerState } from '../../store.types';

export const productTypeSelector = ({ productType }: ReducerState) => productType;
export const productTypeLoadingSelector = createSelector(
  productTypeSelector,
  ({ fetchStatus }) => fetchStatus === fetchStatuses.pending,
);
